export default __webpack_public_path__ + "static/media/BLUD_Mockup.20d84efd.png";